<elder-table [data]="data" class="flex" matSort>
  <!-- id -->
  <ng-container matColumnDef="id">
    <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 15%">
      {{ 'context.id' | translate }}
    </th>
    <td *matCellDef="let type" mat-cell>{{ type.id }}</td>
  </ng-container>

  <!-- name -->
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 20%">
      {{ 'context.name' | translate }}
    </th>
    <td *matCellDef="let type" mat-cell>{{ type.name }}</td>
  </ng-container>

  <!-- kind -->
  <ng-container matColumnDef="kindId">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ 'packageKind.title' | translate }}
    </th>
    <td *matCellDef="let type" mat-cell>
      <div class="layout-col">
        <span>{{ 'packageKind.' + type.kind | translate }}</span>
        <span class="text-body-small">{{ getPackageKindEnumKey(type.kind) }}</span>
      </div>
    </td>
  </ng-container>
</elder-table>
